export default `
  max-width: 600px;
`
